// pico components
import app from './app-instance'
import announcementBar from '../components/announcement-bar'
import collectionLink from '../components/collection-link'
import collectionFilterBy from '../components/collection-filter-by'
import collectionSortBy from '../components/collection-sort-by'
import eventTracking from '../components/event-tracking'
import filterView from '../components/filter-view'
import faqAnchor from '../components/faq-anchor'
import giftNote from '../components/gift-note'
import hyperlinkTracking from '../components/hyperlink-tracking'
import newsletter from '../components/newsletter'
import product from '../components/product'
import purchaseTypeSelector from '../components/purchase-type-selector'
import productDetailsTab from '../components/product-details-tab'
import productModal from '../components/product-modal'
import quantitySelector from '../components/quantity-selector'
import scrollTrackSlider from '../components/scroll-track-slider'
import recommendedProducts from '../components/recommended-products'
import registerNewsletter from '../components/register-newsletter'
import sortByLink from '../components/sort-by-link'
import infiniteScrollGrid from '../components/infinite-scroll-grid'
import ugcSlider from '../components/ugcSlider'
import flavorSlider from '../components/flavor-slider'
import yotpoStarRating from '../components/yotpo-star-rating'
import yotpoMainReviews from '../components/yotpo-main-reviews'
import touchElement from '../components/touchElement'

const components = {
  announcementBar,
  collectionLink,
  collectionFilterBy,
  collectionSortBy,
  eventTracking,
  filterView,
  faqAnchor,
  flavorSlider,
  giftNote,
  hyperlinkTracking,
  infiniteScrollGrid,
  quantitySelector,
  recommendedProducts,
  newsletter,
  product,
  productDetailsTab,
  productModal,
  purchaseTypeSelector,
  registerNewsletter,
  scrollTrackSlider,
  sortByLink,
  touchElement,
  ugcSlider,
  yotpoStarRating,
  yotpoMainReviews,
}

app.add(components)
export default app
